<icms-outlet [components]="model.data.components"
             [name]="'Page content'" />